
import * as ClaimCategoryActions from '@app/modules/claim-categories/actions/claim-category-api.actions';
import { ClaimCategoryTableItemModel } from '@app/modules/claim-categories/models';
import { TableOverviewModel } from '@app/shared/models/table/table-overview.model';
import { TableStateModel } from '@app/shared/models/table/table-state.model';
import { applySortingOrDefault } from '@app/shared/utilities/overview-reducer.utilities';
import { createReducer, on } from '@ngrx/store';

const initialState: State = new TableOverviewModel<ClaimCategoryTableItemModel>('type');

export interface State extends TableStateModel<ClaimCategoryTableItemModel> {}

export const reducer = createReducer(
	initialState,
	on(ClaimCategoryActions.GetOverview, (state) => ({ ...state, loading: true })),
	on(ClaimCategoryActions.GetOverviewSuccess, (state, response) => ({ ...state, ...response, loading: false })),
	on(ClaimCategoryActions.GetOverviewError, (state) => ({ ...state, loading: false })),
	on(ClaimCategoryActions.FilterOverview, (state, { sorting, pagination }) => ({
		...state,
		sorting: applySortingOrDefault(initialState, sorting),
		pagination: {
			...state.pagination,
			page: pagination.page,
			pageSize: pagination.pageSize,
		},
	}))
);

export const getLoading = (state: State) => state.loading;
export const getList = (state: State) => state.list;
export const getPagination = (state: State) => state.pagination;
export const getSorting = (state: State) => state.sorting;
